import Button from '../../../components/base/Button';

interface TestimonialsSectionProps {
  onOpenModal?: () => void;
}

export default function TestimonialsSection({ onOpenModal }: TestimonialsSectionProps) {
  const handleSpecialistClick = () => {
    if (onOpenModal) {
      onOpenModal();
    }
  };

  const testimonials = [
    {
      name: 'Ana Carolina Silva',
      role: 'Gerente de Marketing',
      company: 'Tech Solutions',
      image: 'https://readdy.ai/api/search-image?query=Professional%20confident%20businesswoman%20smiling%20in%20modern%20office%20environment%2C%20corporate%20headshot%20style%2C%20warm%20lighting%2C%20elegant%20and%20approachable%20appearance%2C%20clean%20background&width=150&height=150&seq=testimonial-ana&orientation=squarish',
      text: 'Antes da Vox2You, eu evitava apresentações. Hoje lidero reuniões com 50+ pessoas e recebi uma promoção! A metodologia realmente funciona.',
      rating: 5
    },
    {
      name: 'Roberto Mendes',
      role: 'Diretor Comercial',
      company: 'Inovação Corp',
      image: 'https://readdy.ai/api/search-image?query=Professional%20confident%20businessman%20in%20suit%20smiling%20in%20modern%20corporate%20office%2C%20executive%20headshot%20style%2C%20natural%20lighting%2C%20trustworthy%20and%20successful%20appearance%2C%20clean%20background&width=150&height=150&seq=testimonial-roberto&orientation=squarish',
      text: 'Minha timidez me limitava profissionalmente. Após o curso, minha comunicação melhorou 200%. Consegui fechar negócios que antes eram impossíveis.',
      rating: 5
    },
    {
      name: 'Mariana Costa',
      role: 'Empreendedora',
      company: 'Startup Digital',
      image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=150&h=150&q=80',
      text: 'Como empreendedora, precisava convencer investidores. A Vox2You me deu as ferramentas para apresentar minha startup com segurança total.',
      rating: 5
    },
    {
      name: 'Carlos Eduardo',
      role: 'Engenheiro Sênior',
      company: 'Construtech',
      image: 'https://readdy.ai/api/search-image?query=Professional%20confident%20middle-aged%20engineer%20in%20business%20casual%20attire%20smiling%20in%20modern%20office%2C%20technical%20professional%20headshot%20style%2C%20natural%20lighting%2C%20competent%20and%20reliable%20appearance%2C%20clean%20background&width=150&height=150&seq=testimonial-carlos&orientation=squarish',
      text: 'Sempre fui técnico, mas comunicar era meu ponto fraco. Hoje conduzo treinamentos para toda a equipe. Transformação completa!',
      rating: 5
    },
    {
      name: 'Juliana Santos',
      role: 'Consultora RH',
      company: 'People First',
      image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=150&h=150&q=80',
      text: 'Trabalho com pessoas, mas tinha dificuldade em palestras. O curso me deu técnicas práticas que uso diariamente. Recomendo 100%!',
      rating: 5
    },
    {
      name: 'Fernando Lima',
      role: 'Advogado',
      company: 'Lima & Associados',
      image: 'https://readdy.ai/api/search-image?query=Professional%20confident%20lawyer%20in%20suit%20smiling%20in%20modern%20law%20office%2C%20legal%20professional%20headshot%20style%2C%20formal%20lighting%2C%20authoritative%20and%20trustworthy%20appearance%2C%20clean%20background&width=150&height=150&seq=testimonial-fernando&orientation=squarish',
      text: 'No tribunal, a oratória é fundamental. A Vox2You aprimorou minha argumentação e presença. Meus resultados melhoraram significativamente.',
      rating: 5
    }
  ];

  return (
    <section id="depoimentos" className="py-12 sm:py-16 lg:py-20 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10 sm:mb-12 lg:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4 sm:mb-6">
            Histórias Reais de 
            <span className="text-[#F19E1A]"> Transformação</span>
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-gray-600 max-w-3xl mx-auto px-4">
            Veja como nossos alunos desbloquearam, de forma definitiva, todo o talento que têm e transformaram as suas trajetórias com a Vox2you.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8 mb-8 sm:mb-10 lg:mb-12">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-white rounded-xl sm:rounded-2xl p-6 sm:p-8 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
              {/* Rating */}
              <div className="flex mb-3 sm:mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-[#F19E1A] text-sm sm:text-base"></i>
                ))}
              </div>
              
              {/* Testimonial Text */}
              <p className="text-sm sm:text-base text-gray-600 mb-4 sm:mb-6 italic leading-relaxed">
                "{testimonial.text}"
              </p>
              
              {/* Author */}
              <div className="flex items-center">
                <img
                  src={testimonial.image}
                  alt={testimonial.name}
                  className="w-11 h-11 sm:w-12 sm:h-12 rounded-full object-cover mr-3 sm:mr-4 flex-shrink-0"
                />
                <div>
                  <div className="font-semibold text-gray-900 text-sm sm:text-base">{testimonial.name}</div>
                  <div className="text-xs sm:text-sm text-gray-600">{testimonial.role}</div>
                  <div className="text-xs sm:text-sm text-[#F19E1A]">{testimonial.company}</div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <Button 
            size="lg" 
            onClick={handleSpecialistClick}
            className="text-base sm:text-lg px-6 sm:px-8 py-3 sm:py-4 w-full sm:w-auto"
          >
            💬 Quero viver esta transformação
          </Button>
        </div>
      </div>
    </section>
  );
}

